/**
 * A step card's header: its number, tool and integration, how it ended in the last test run, and a
 * menu for what is not a wire (waiting for another step, removing it). The ports on either side take
 * a drag from one step to another, which sets the second to run after the first.
 */

import type { ToolDefinitionAction } from '@/services/toolDefinition.service';
import type { CustomToolStep } from '@/types/custom-tool.types';
import { StepBadges } from '../../steps/step-badges';
import { StepMenu } from '../../steps/step-menu';
import { StepTitle } from '../../steps/step-title';
import { RUN_FROM_PORT, RUN_TO_PORT } from '../ports';
import { INTERACTIVE } from './card';
import { Port } from './port';

interface StepHeaderProps {
	step: CustomToolStep;
	index: number;
	tool: ToolDefinitionAction | undefined;
}

export const StepHeader = ({ step, index, tool }: StepHeaderProps) => (
	<div className='relative flex h-14 items-center gap-2 px-3'>
		<Port id={RUN_TO_PORT} type='target' side='left' tone='run' />
		<StepTitle step={step} index={index} tool={tool} />
		<StepBadges step={step} tool={tool} className={INTERACTIVE} />
		<StepMenu step={step} index={index} className={INTERACTIVE} />
		<Port id={RUN_FROM_PORT} type='source' side='right' tone='run' />
	</div>
);
